module.exports = __webpack_public_path__ + "assets/img/contact.992ea5ee.svg";